import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UserEditIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M7.15749 3.05953C8.47607 2.5195 9.9212 2.36626 11.3237 2.61774C12.7262 2.86923 14.0281 3.51503 15.0769 4.47956C16.1257 5.44409 16.878 6.68742 17.2458 8.06401C17.3646 8.50865 17.1005 8.96541 16.6558 9.08421C16.2112 9.20301 15.7544 8.93887 15.6356 8.49423C15.3496 7.42355 14.7644 6.45651 13.9487 5.70632C13.133 4.95614 12.1204 4.45384 11.0296 4.25824C9.93871 4.06265 8.81472 4.18183 7.78916 4.60186C6.7636 5.02188 5.87891 5.72536 5.23865 6.62994C4.59839 7.53452 4.22906 8.60278 4.1739 9.70964C4.11874 10.8165 4.38002 11.9162 4.92716 12.8799C5.07348 13.1377 5.23863 13.3828 5.42079 13.6137C6.10807 12.9207 7.06158 12.4905 8.1162 12.4905H8.17057C8.22949 12.4905 8.28697 12.4966 8.34242 12.5083C8.42627 12.5028 8.51086 12.5 8.59611 12.5H11.25C11.7102 12.5 12.0833 12.8731 12.0833 13.3333C12.0833 13.7936 11.7102 14.1667 11.25 14.1667H8.59611C7.92337 14.1667 7.32119 14.4734 6.9233 14.956C7.0342 15.0248 7.14762 15.0901 7.26339 15.1516C7.78158 15.4268 8.3356 15.6209 8.90625 15.7299C9.35833 15.8162 9.65485 16.2526 9.56855 16.7047C9.48226 17.1568 9.04582 17.4533 8.59375 17.367C7.86007 17.2269 7.14774 16.9774 6.4815 16.6235C5.22315 15.955 4.18125 14.9419 3.47778 13.7028C2.77431 12.4637 2.43837 11.0498 2.5093 9.62668C2.58022 8.20357 3.05507 6.8301 3.87826 5.66707C4.70145 4.50404 5.83891 3.59956 7.15749 3.05953ZM10 6.50004C8.98748 6.50004 8.16667 7.32085 8.16667 8.33337C8.16667 9.34587 8.98749 10.1667 10 10.1667C11.0125 10.1667 11.8333 9.34587 11.8333 8.33337C11.8333 7.32086 11.0125 6.50004 10 6.50004ZM6.5 8.33337C6.5 6.40038 8.06701 4.83337 10 4.83337C11.933 4.83337 13.5 6.40037 13.5 8.33337C13.5 10.2663 11.933 11.8334 10 11.8334C8.067 11.8334 6.5 10.2663 6.5 8.33337Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M12.1695 15.7912C12.0357 15.925 11.9514 16.1004 11.9305 16.2884L11.7995 17.468C11.7877 17.5741 11.8774 17.6638 11.9835 17.652L13.1631 17.521C13.3511 17.5001 13.5265 17.4158 13.6603 17.282L17.5532 13.3891C17.9649 12.9774 17.9649 12.31 17.5532 11.8983C17.1415 11.4866 16.4741 11.4866 16.0624 11.8983L12.1695 15.7912Z"
      fill="currentColor"
    />
  </svg>
);

UserEditIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UserEditIcon);
